import { MoreVertical } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

export function ActionDropdown({ items }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={containerRef}>
      <button
        onClick={() => setOpen(!open)}
        className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 cursor-pointer"
        aria-label="Actions"
      >
        <MoreVertical size={18} />
      </button>

      {open && (
        <div className="absolute bottom-full right-0 z-50 mb-2 w-48 origin-bottom-right rounded-xl border border-slate-200 bg-white p-1.5 shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <button
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  item.onClick();
                  setOpen(false);
                }}
                title={item.label}
                className={cn(
                  "flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm font-medium transition cursor-pointer",
                  item.variant === "danger"
                    ? "text-red-600 hover:bg-red-50 hover:text-red-700"
                    : item.variant === "gold"
                      ? "text-amber-700 hover:bg-amber-50"
                      : "text-slate-700 hover:bg-slate-100"
                )}
              >
                <Icon size={18} className="shrink-0" />
                {item.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
